import { BehaviorSubject } from 'rxjs';
import { CancelTranscService } from 'app/services/cancel-transc.service';
import * as i0 from "@angular/core";
import * as i1 from "./cancel-transc.service";
var TransactionLogService = /** @class */ (function () {
    function TransactionLogService(cancelService) {
        this.cancelService = cancelService;
        this.socketProcesses = new BehaviorSubject([]);
        this.statusMessage = new BehaviorSubject('init message');
    }
    TransactionLogService.prototype.cancelProcess = function (processId) {
        var _this = this;
        var process = this.socketProcesses.value.find(function (p) { return p.id === processId; });
        // Cancel the process
        this.cancelService.cancelTransc(processId, function () {
            // Update process type as canceling
            // This should be set after cancelTransc is successfully called.
            if (process.status !== 'Completed' || 'Error') { // if process already finished, do not update status
                process.status = 'Canceling';
                var filtered = _this.socketProcesses.value.filter(function (t) { return t.id !== process.id; });
                _this.socketProcesses.next(filtered.concat(process));
            }
        });
    };
    TransactionLogService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TransactionLogService_Factory() { return new TransactionLogService(i0.ɵɵinject(i1.CancelTranscService)); }, token: TransactionLogService, providedIn: "root" });
    return TransactionLogService;
}());
export { TransactionLogService };
